export default "__VITE_ASSET__DWWx1adH__"